import { render, staticRenderFns } from "./withdrawal-success.vue?vue&type=template&id=e049c076&scoped=true&"
import script from "./withdrawal-success.vue?vue&type=script&lang=js&"
export * from "./withdrawal-success.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-success.vue?vue&type=style&index=0&id=e049c076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e049c076",
  null
  
)

export default component.exports